import axios from 'axios';
export const backendUrl ="https://businessxstreambackend.aivonexskills.com";
// export const backendUrl = "http://localhost:5000";
const token = localStorage.getItem("admintoken");


const axiosInstance  = axios.create({
    baseURL: backendUrl,
    headers: {
        'Content-Type': 'application/json',
        'Authorization' : `Bearer ${token}`
    }
})

export default axiosInstance ;